import { Component, OnInit } from '@angular/core';
import { LanguageSelectorModel } from './model/language-selector.model';
import { LANGUAGES } from './language-selector-data';
import { LanguageSelectorService } from './service/language-selector.service';

@Component({
  selector: 'prep-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  languages: LanguageSelectorModel[] = LANGUAGES;
  selectedLang: LanguageSelectorModel = this.languages[0];

  labels: { [key: string]: { label: string; aria: string } } = {
    en: { label: 'Language', aria: 'Language selector' },
    es: { label: 'Idioma', aria: 'Selector de idioma' },
    it: { label: 'Lingua', aria: 'Selettore della lingua' },
  };

  // Getters to return correct label text
  get currentLabel(): string {
    return this.labels[this.selectedLang.code]?.label || 'Language';
  }

  get currentAriaLabel(): string {
    return this.labels[this.selectedLang.code]?.aria || 'Language selector';
  }

  constructor(private languageSelectorService: LanguageSelectorService) {}

  ngOnInit(): void {
    this.selectedLang = this.languageSelectorService.getCurrentLanguage();
  }

  onLanguageChange(code: string): void {
    const selected = this.languages.find((lang) => lang.code === code);
    if (selected) {
      this.selectedLang = selected;
      this.languageSelectorService.setLanguage(selected);
    }
  }
}
